export const caregiversHealthCareQuery = `query Caregivers(
    $query: String!
    $postalCode: String!
    $careGiverType: String
) {
    caregiversHealthCare(
       query: $query
       postalCode: $postalCode
       careGiverType: $careGiverType
    ) {
       partyCaregivers {
          externalSourceName
          name
          searchId
          externalSourceName
          careType
          distanceToPolicyHolderInKilometers
          policyPolicyDetails {
              contractStatus
              contractNumber
          }
       }
    }
}`;
